import { isOfType } from 'common/helpers'
import type { Nullable } from 'common/types'

const ContextMenuItem = [
  'ImportFromFile',
  'ImportFromDB',
  'ToBookmarks',
  'Properties',
  'Export',
  'ToBin',
  'ToObject',
  'Rename',
  'NewObject',
  'Processes',
  'Actions',
  'CreateFolder',
  'Status',
  'OpenInTable',
  'Publish',
  'Copy',
] as const

const SubMenuUploadFile = [
  'WellheadCoordinates',
  'Inclinometry',
  'GIS',
  'RIGIS',
  'Markers',
  'VSP',
  'Survey2D',
  'Survey3D',
  'Horizon',
  'Fault',
  'Stick',
  'Polygons',
  'Maps',
  'Attribute',
] as const

const SubMenuNewObject = [
  'CreateMarker',
  'CreateArea',
  'CreateHorizon',
  'CreateFault',
  'CreateILine',
  'CreateXLine',
  'CreateZSlice',
] as const

const SubMenuProcesses = ['Mapping'] as const
const SubMenuActions = ['ConvertToDots', 'ConvertToPolygons'] as const
const SubMenuExport = ['Charisma', 'Export_IrapGrid', 'ExportIrapPolygon'] as const

export type ContextMenuItemType = (typeof ContextMenuItem)[number]
export type SubMenuUploadFileType = (typeof SubMenuUploadFile)[number]
type SubMenuNewObjectType = (typeof SubMenuNewObject)[number]
export type SubMenuProcessesType = (typeof SubMenuProcesses)[number]
export type SubMenuActionsType = (typeof SubMenuActions)[number]
export type SubMenuExportType = (typeof SubMenuExport)[number]

export type SubMenuItemType =
  | SubMenuUploadFileType
  | SubMenuNewObjectType
  | SubMenuProcessesType
  | SubMenuActionsType
  | SubMenuExportType

export type ContextMenuType = {
  id: string
  items: ContextMenuElementType[]
}

export type ContextMenuElementType = {
  label: string
  type: ContextMenuItemType | SubMenuItemType
  group?: number
  subMenu?: Nullable<ContextMenuElementType[]>
}

export const isContextMenuItem = isOfType(ContextMenuItem)
export const isSubMenuUploadFile = isOfType(SubMenuUploadFile)
export const isSubMenuNewObject = isOfType(SubMenuNewObject)
export const isSubMenuProcesses = isOfType(SubMenuProcesses)
export const isSubMenuActions = isOfType(SubMenuActions)
export const isSubMenuExport = isOfType(SubMenuExport)
